import LazyLoad from 'vanilla-lazyload';
import 'intersection-observer';

import { trackHeaderClick } from 'global/header/scripts/trackHeaderClick';
import { trackScreenView } from 'global/services';
import { displaySpecificStoreButton } from 'global/layouts/footer';


import configureRaven from 'app/configure-raven';

// import { setUpNyTreeToyTouchPoint } from 'global/layouts/ny2023';
import { registerFAQAreaEvents } from '../../index/src/scripts/faqArea';
import initializeApp from './app/promo-app';
import { startNyAnimation } from './pages/blyuda-dlya-novogodnego-stola/scrollPeopleBunner';

import initializeCollapse from '../../trial/src/scripts/collapse';

import './styles/index.scss';
import { dispatchBR1173Events } from './scripts/analytics';
import { dispatchSquidGameEvents } from './scripts/analytics/squidGameAnalytics';


configureRaven();

function addLangToggleHandler() {
    const button = document.querySelector('.js-toggle-city-dropdown');
    const dropdown = document.querySelector('.js-city-dropdown');

    if (!button || !dropdown) return;

    button.addEventListener('click', () => {
        dropdown.classList.toggle('is-open');
        button.classList.toggle('is-open');
    });
}

async function getConfig() {
    // if (process.env.PAGE) {
    //     return configs[process.env.PAGE];
    // }
    if (process.env.PAGES) {
        const { pageId } = document.body.dataset;
        const { default: config } = await import(`./pages/${pageId}/build-config`);
        return config;
    }

    return {};
}

async function onLoad() {
    const config = await getConfig();

    startNyAnimation(config);

    if (config.onInit) {
        config.onInit();
    }

    initializeApp(config.appConfig);
    addLangToggleHandler();
    // eslint-disable-next-line
    new LazyLoad();

    trackHeaderClick();
    trackScreenView(window.location.pathname);

    initializeCollapse('[data-collapse-item]');
    displaySpecificStoreButton();

    dispatchBR1173Events();
    dispatchSquidGameEvents();
    registerFAQAreaEvents();
    // setUpNyTreeToyTouchPoint();
    // HALLOWEEN PAGE HANDLERS
}


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        onLoad();
    });
} else {
    onLoad();
}
